module.exports = __webpack_public_path__ + "static/media/bigbags.06f9d332.png";